module.exports = __webpack_public_path__ + "static/fund-5d14a4e365e7a2a55c7bc2629b1ab32f.png";